import { render, staticRenderFns } from "./applySalePkg.vue?vue&type=template&id=9b448454&scoped=true&"
import script from "./applySalePkg.vue?vue&type=script&lang=js&"
export * from "./applySalePkg.vue?vue&type=script&lang=js&"
import style0 from "./applySalePkg.vue?vue&type=style&index=0&id=9b448454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b448454",
  null
  
)

export default component.exports